import { QueryClient } from '@tanstack/react-query';

/**
 * Defaults follow TDD §3.4:
 *   - SWR: short staleTime; real-time modules tune down further.
 *   - Refetch on focus is ON globally; reports screens override to OFF.
 *   - Retries default to 2 on queries; mutations do not auto-retry (they're
 *     business actions — the feature decides).
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        retry: 2,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
